import { useState, useLayoutEffect } from 'react';

/**
 *  현재 너비의 디바이스를 리턴하는 hook
 * @returns mobile or pc
 *  */
function useDevice(): string {
  const [device, setDevice] = useState<string>('pc');

  useLayoutEffect(() => {
    if (document.body.offsetWidth <= 768) {
      /* 모바일 사이즈 일 때, device가 mobile이 아니면 mobile로 dispatch */
      setDevice('mobile');
    } else {
      /* 데스크탑 사이즈 일 때, device가 pc이 아니면 pc으로 dispatch */
      setDevice('pc');
    }
  }, []);

  useLayoutEffect(() => {
    const handleResize = (): void => {
      if (document.body.offsetWidth <= 768) {
        /* 모바일 사이즈 일 때, device가 mobile이 아니면 mobile로 dispatch */
        if (device !== 'mobile') {
          setDevice('mobile');
        }
      } else {
        /* 데스크탑 사이즈 일 때, device가 pc이 아니면 pc으로 dispatch */
        if (device !== 'pc') {
          setDevice('pc');
        }
      }
    };

    /* 화면 크기가 변경 될 때를 감지 */
    window.addEventListener('resize', handleResize);

    return () => {
      // clean up
      window.removeEventListener('resize', handleResize);
    };
  }, [device]);

  return device;
}

export default useDevice;
